import React, { useState } from 'react'
import { makeStyles } from '@mui/styles'

import IconWarn from 'assets/images/icons/v2/warning.svg'

import { ButtonSquare } from '@/modules/base/components/buttons'
import Checkbox from '@/modules/base/components/inputs/checkbox/checkbox'
import avvPdf from '@assets/downloads/avv-orgamax-102024.pdf'
import customTheme from '@/theme'
import lang from '@/lang'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
const { avvModal } = lang

const AcceptAvvForm = (props) => {
  const { onConfirm } = props
  const classes = useStyles()
  const [isAccepted, setIsAccepted] = useState(false)
  const [formIsValid, setFormIsValid] = useState(false)

  const handleConfirmClick = (event) => {
    const { nativeEvent } = event
    nativeEvent.preventDefault()
    nativeEvent.stopImmediatePropagation()

    onConfirm && onConfirm({ isAccepted })
  }

  const handleChangeAvvCheck = (isAccepted) => {
    setIsAccepted(isAccepted)
    setFormIsValid(isAccepted)
  }

  const onAVVClicked = (event) => {
    event.stopPropagation()
    window.open(avvPdf)
  }

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <form className={classes.form} id='code' onSubmit={handleConfirmClick}>
          <SVGIcon width='50px' height='50px' svg={IconWarn} fill={customTheme.red} />
          <div className={classes.header}>{avvModal.title}</div>
          <p className={classes.description}>
            {avvModal.sections[0]}
          </p>
          <p className={classes.description}>
            {avvModal.sections[1]}<a onClick={onAVVClicked}>{avvModal.sections[2]}</a>{avvModal.sections[3]}</p>
          <ul className={classes.listContainer}>
            <li>{avvModal.sections[4]}</li>
            <li>{avvModal.sections[5]}</li>
            <li>{avvModal.sections[6]}</li>
          </ul>
          <Checkbox
            onChange={handleChangeAvvCheck}
            name='acceptAvv'
            inputPosition="mid"
            customClass={classes.checkboxContainer}>
            <span className={classes.checkboxLabel}>
              {avvModal.cbTexts[0]}<a onClick={onAVVClicked}>{avvModal.cbTexts[1]}</a>{avvModal.cbTexts[2]}</span>
          </Checkbox>
          <ButtonSquare
            disabled={!formIsValid}
            type='submit'
            label={avvModal.acknlowedgeButton}
            customClass={classes.button}
            form='code' />
        </form>
      </div>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    textAlign: 'center',
    height: '100%',
    padding: '40px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: '0 0 90%',
  },
  header: {
    fontSize: 24,
    margin: '15px 0px 50px',
  },
  description: {
    padding: '0px',
    marginBottom: 20,
    textAlign: 'left',
  },
  form: {
    width: '100%',
    justifyContent: 'left',
    margin: 0,
  },
  listContainer: {
    textAlign: 'left',
    width: '100%',
    paddingLeft: '15px',
    '& > li': {
      listStyleType: 'disc',
    },
  },
  resend: {
    textAlign: 'center',
    color: theme.primary,
    marginBottom: 65,
  },
  button: {
    display: 'flex',
    fontSize: '13px',
    justifyContent: 'center',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    flex: '0 0 50px',
  },
  checkboxContainer: {
    margin: '20px 45px 50px 0',
  },
  checkboxLabel: {
    textAlign: 'left',
    paddingLeft: '20px',
  },
}))

export default AcceptAvvForm
